var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { encode, instantiate } from 'media-encoder-host';
import { MultiBufferDataView } from 'multi-buffer-data-view';
import { on } from 'subscribable-things';
export var createWebmPcmMediaRecorderFactory = function (createBlobEvent, decodeWebMChunk, readVariableSizeInteger) {
    return function (eventTarget, nativeMediaRecorderConstructor, mediaStream, mimeType) {
        var bufferedArrayBuffers = [];
        var nativeMediaRecorder = new nativeMediaRecorderConstructor(mediaStream, { mimeType: 'audio/webm; codecs=pcm' });
        var promisedPartialRecording = null;
        var stopRecording = function () { }; // tslint:disable-line:no-empty
        var dispatchDataAvailableEvent = function (arrayBuffers) {
            eventTarget.dispatchEvent(createBlobEvent('dataavailable', { data: new Blob(arrayBuffers, { type: mimeType }) }));
        };
        var requestNextPartialRecording = function (encoderInstanceId, timeslice) { return __awaiter(void 0, void 0, void 0, function () {
            var arrayBuffers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, encode(encoderInstanceId, timeslice)];
                    case 1:
                        arrayBuffers = _a.sent();
                        if (nativeMediaRecorder.state === 'inactive') {
                            bufferedArrayBuffers.push.apply(bufferedArrayBuffers, __spreadArray([], __read(arrayBuffers), false));
                        }
                        else {
                            dispatchDataAvailableEvent(arrayBuffers);
                            promisedPartialRecording = requestNextPartialRecording(encoderInstanceId, timeslice);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var stop = function () {
            if (nativeMediaRecorder.state === 'inactive') {
                return;
            }
            if (promisedPartialRecording !== null) {
                promisedPartialRecording.catch(function () {
                    /* @todo Only catch the errors caused by a duplicate call to encode. */
                });
                promisedPartialRecording = null;
            }
            stopRecording();
            stopRecording = function () { }; // tslint:disable-line:no-empty
            nativeMediaRecorder.stop();
        };
        nativeMediaRecorder.addEventListener('error', function (event) {
            stop();
            eventTarget.dispatchEvent(new ErrorEvent('error', {
                error: event.error
            }));
        });
        nativeMediaRecorder.addEventListener('pause', function () { return eventTarget.dispatchEvent(new Event('pause')); });
        nativeMediaRecorder.addEventListener('resume', function () { return eventTarget.dispatchEvent(new Event('resume')); });
        nativeMediaRecorder.addEventListener('start', function () { return eventTarget.dispatchEvent(new Event('start')); });
        return {
            get mimeType() {
                return mimeType;
            },
            get state() {
                return nativeMediaRecorder.state;
            },
            pause: function () {
                return nativeMediaRecorder.pause();
            },
            resume: function () {
                return nativeMediaRecorder.resume();
            },
            start: function (timeslice) {
                var _this = this;
                var _a = __read(mediaStream.getAudioTracks(), 1), audioTrack = _a[0];
                if (audioTrack !== undefined && nativeMediaRecorder.state === 'inactive') {
                    // Bug #19: Chrome does not expose the correct channelCount property right away.
                    var _b = audioTrack.getSettings(), channelCount_1 = _b.channelCount, sampleRate = _b.sampleRate;
                    if (channelCount_1 === undefined) {
                        throw new Error('The channelCount is not defined.');
                    }
                    if (sampleRate === undefined) {
                        throw new Error('The sampleRate is not defined.');
                    }
                    var isRecording_1 = false;
                    var isStopped_1 = false;
                    // Bug #9: Chrome sometimes fires more than one dataavailable event while being inactive.
                    var pendingInvocations_1 = 0;
                    var promisedDataViewElementTypeEncoderInstanceIdAndPort_1 = instantiate(mimeType, sampleRate);
                    stopRecording = function () {
                        isStopped_1 = true;
                    };
                    var removeEventListener_1 = on(nativeMediaRecorder, 'dataavailable')(function (_a) {
                        var data = _a.data;
                        pendingInvocations_1 += 1;
                        var promisedArrayBuffer = data.arrayBuffer();
                        promisedDataViewElementTypeEncoderInstanceIdAndPort_1 = promisedDataViewElementTypeEncoderInstanceIdAndPort_1.then(function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
                            var arrayBuffer, currentDataView, lengthAndValue, value, _c, currentElementType, offset, contents, remainingDataView;
                            var _d = _b.dataView, dataView = _d === void 0 ? null : _d, _e = _b.elementType, elementType = _e === void 0 ? null : _e, encoderInstanceId = _b.encoderInstanceId, port = _b.port;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0: return [4 /*yield*/, promisedArrayBuffer];
                                    case 1:
                                        arrayBuffer = _f.sent();
                                        pendingInvocations_1 -= 1;
                                        currentDataView = dataView === null
                                            ? new MultiBufferDataView([arrayBuffer])
                                            : new MultiBufferDataView(__spreadArray(__spreadArray([], __read(dataView.buffers), false), [arrayBuffer], false), dataView.byteOffset);
                                        if (!isRecording_1 && nativeMediaRecorder.state === 'recording' && !isStopped_1) {
                                            lengthAndValue = readVariableSizeInteger(currentDataView, 0);
                                            if (lengthAndValue === null) {
                                                return [2 /*return*/, { dataView: currentDataView, elementType: elementType, encoderInstanceId: encoderInstanceId, port: port }];
                                            }
                                            value = lengthAndValue.value;
                                            if (value !== 172351395) {
                                                return [2 /*return*/, { dataView: dataView, elementType: elementType, encoderInstanceId: encoderInstanceId, port: port }];
                                            }
                                            isRecording_1 = true;
                                        }
                                        _c = decodeWebMChunk(currentDataView, elementType, channelCount_1), currentElementType = _c.currentElementType, offset = _c.offset, contents = _c.contents;
                                        remainingDataView = offset < currentDataView.byteLength
                                            ? new MultiBufferDataView(currentDataView.buffers, currentDataView.byteOffset + offset)
                                            : null;
                                        contents.forEach(function (content) { return port.postMessage(content, content.map(function (_a) {
                                            var buffer = _a.buffer;
                                            return buffer;
                                        })); });
                                        if (pendingInvocations_1 === 0 && (nativeMediaRecorder.state === 'inactive' || isStopped_1)) {
                                            encode(encoderInstanceId, null).then(function (arrayBuffers) {
                                                dispatchDataAvailableEvent(__spreadArray(__spreadArray([], __read(bufferedArrayBuffers), false), __read(arrayBuffers), false));
                                                bufferedArrayBuffers.length = 0;
                                                eventTarget.dispatchEvent(new Event('stop'));
                                            });
                                            port.postMessage([]);
                                            port.close();
                                            removeEventListener_1();
                                        }
                                        return [2 /*return*/, { dataView: remainingDataView, elementType: currentElementType, encoderInstanceId: encoderInstanceId, port: port }];
                                }
                            });
                        }); });
                    });
                    if (timeslice !== undefined) {
                        promisedDataViewElementTypeEncoderInstanceIdAndPort_1.then(function (_a) {
                            var encoderInstanceId = _a.encoderInstanceId;
                            if (isStopped_1) {
                                return;
                            }
                            promisedPartialRecording = requestNextPartialRecording(encoderInstanceId, timeslice);
                        });
                    }
                }
                nativeMediaRecorder.start(100);
            },
            stop: stop
        };
    };
};
//# sourceMappingURL=webm-pcm-media-recorder.js.map
